import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { type ChipVariant } from '@shared/components/chip/chip.types';
import { Dynamic, type DynamicAction } from '@shared/registry/dynamic';

import { type AppointmentCardConfig } from './appointment-card.types';

@Component({
  selector: 'app-appointment-card',
  templateUrl: './appointment-card.html',
  imports: [Dynamic],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentCard {
  readonly config = input.required<AppointmentCardConfig>();

  readonly action = output<DynamicAction>();

  protected readonly chipVariant = computed<ChipVariant>(() => {
    if (this.config().chipVariant) return this.config().chipVariant!;
    const cssValue = getComputedStyle(document.documentElement)
      .getPropertyValue('--appointment-card-chip-variant')
      .trim();
    return (cssValue as ChipVariant) || 'primary';
  });

  protected onButtonClick(event: DynamicAction): void {
    this.action.emit(event);
  }
}
